/* me-ticket.js v1.1 — Ticket Support & My Support（多图上传 + Canvas 压缩） */
(function () {
  var root = document.getElementById("me-ticket-root");
  if (!root) return;
  if (root.dataset.meInit) return;
  root.dataset.meInit = "1";

  var erpBase = (root.dataset.erpUrl || "").replace(/\/$/, "");
  var shopCode = root.dataset.shopCode || "";
  var customerEmail = (root.dataset.customerEmail || "").trim().toLowerCase();
  var customerId = root.dataset.customerId || "";
  var customerName = root.dataset.customerName || "";
  var supportUrl = root.dataset.supportUrl || "/pages/support";
  var chatUrl = root.dataset.chatUrl || "";
  var faqUrl = root.dataset.faqUrl || "/pages/f-qs";
  var serviceEmail = root.dataset.serviceEmail || "";
  var pageMode = root.dataset.pageMode || "support"; // "support" or "my-support"

  /* ── Utility ── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }
  function escHtml(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }

  function formatDate(v) {
    if (!v) return "";
    var d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    var mon = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return mon[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear() + " " + pad(d.getHours()) + ":" + pad(d.getMinutes());
  }
  function pad(n) { return n < 10 ? "0" + n : String(n); }

  function statusHtml(status, label) {
    return '<span class="me-tk-status me-tk-status-' + escHtml(String(status)) + '">' + escHtml(label || statusLabel(status)) + '</span>';
  }
  function statusLabel(s) {
    if (s == 1) return "Open";
    if (s == 2) return "Waiting for your reply";
    if (s == 3) return "Waiting for support";
    if (s == 4) return "Closed";
    return "Unknown";
  }

  function apiGet(path, params, cb) {
    if (!erpBase) {
      cb({ code: 1, msg: "Support service is not configured" });
      return;
    }
    var url = erpBase + path;
    var parts = [];
    for (var k in params) {
      if (params[k] !== undefined && params[k] !== null && params[k] !== "") {
        parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(params[k]));
      }
    }
    if (parts.length) url += "?" + parts.join("&");
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.withCredentials = false;
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        try { cb(JSON.parse(xhr.responseText)); } catch (e) { cb({ code: 1, msg: "Network error" }); }
      }
    };
    xhr.onerror = function () { cb({ code: 1, msg: "Network error" }); };
    xhr.send();
  }

  function apiPost(path, formData, cb) {
    if (!erpBase) {
      cb({ code: 1, msg: "Support service is not configured" });
      return;
    }
    var url = erpBase + path;
    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.withCredentials = false;
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        try { cb(JSON.parse(xhr.responseText)); } catch (e) { cb({ code: 1, msg: "Network error" }); }
      }
    };
    xhr.onerror = function () { cb({ code: 1, msg: "Network error" }); };
    xhr.send(formData);
  }

  /* 压缩图片：长边 2560px 上限，JPEG 0.92 质量；用回调风格兼容 IE11 */
  function compressImage(file, onDone) {
    // 非图片或 gif 直接原样返回（gif 压缩会丢动画）
    if (!file.type || file.type.indexOf("image/") !== 0 || file.type === "image/gif") {
      onDone(file);
      return;
    }
    var reader = new FileReader();
    reader.onerror = function () { onDone(file); };
    reader.onload = function (ev) {
      var img = new Image();
      img.onerror = function () { onDone(file); };
      img.onload = function () {
        var maxSide = 2560;
        var w = img.naturalWidth, h = img.naturalHeight;
        if (w <= maxSide && h <= maxSide && file.size < 1500 * 1024) {
          // 小图不压缩
          onDone(file);
          return;
        }
        var scale = Math.min(1, maxSide / Math.max(w, h));
        var tw = Math.round(w * scale), th = Math.round(h * scale);
        var canvas = document.createElement("canvas");
        canvas.width = tw; canvas.height = th;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";  // png 透明背景填白，避免 JPEG 黑底
        ctx.fillRect(0, 0, tw, th);
        ctx.drawImage(img, 0, 0, tw, th);
        var mime = "image/jpeg";
        try {
          canvas.toBlob(function (blob) {
            if (!blob) { onDone(file); return; }
            var newName = (file.name || "image").replace(/\.[^.]+$/, "") + ".jpg";
            var newFile;
            try {
              newFile = new File([blob], newName, { type: mime });
            } catch (e) {
              blob.name = newName;
              newFile = blob;
            }
            onDone(newFile);
          }, mime, 0.92);
        } catch (e) { onDone(file); }
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  }

  /* ══════════════════════════════════════
     Support Page (Submit + Check + Cards)
     ══════════════════════════════════════ */
  if (pageMode === "support") {
    initSupportPage();
  }

  function initSupportPage() {
    /* ── Tab switching ── */
    var tabs = qsa(".me-tk-tab", root);
    var panels = qsa(".me-tk-panel", root);
    var heroBtns = document.querySelectorAll(".me-tk-hero-btn");

    function activateTab(idx) {
      for (var j = 0; j < tabs.length; j++) {
        tabs[j].classList.remove("is-active");
        tabs[j].setAttribute("aria-selected", "false");
        tabs[j].setAttribute("tabindex", "-1");
        panels[j].classList.remove("is-active");
        panels[j].setAttribute("aria-hidden", "true");
      }
      for (var j = 0; j < heroBtns.length; j++) { heroBtns[j].classList.remove("me-tk-hero-btn-active"); }
      if (tabs[idx]) {
        tabs[idx].classList.add("is-active");
        tabs[idx].setAttribute("aria-selected", "true");
        tabs[idx].setAttribute("tabindex", "0");
      }
      if (panels[idx]) {
        panels[idx].classList.add("is-active");
        panels[idx].setAttribute("aria-hidden", "false");
      }
      if (heroBtns[idx]) heroBtns[idx].classList.add("me-tk-hero-btn-active");
    }

    for (var i = 0; i < tabs.length; i++) {
      (function (idx) {
        tabs[idx].addEventListener("click", function () {
          activateTab(idx);
        });
      })(i);
    }
    for (var i = 0; i < heroBtns.length; i++) {
      (function (idx) {
        heroBtns[idx].addEventListener("click", function () {
          activateTab(idx);
        });
      })(i);
    }

    /* ── Load topics ── */
    var topicSel = qs("#me-tk-topic", root);
    var topicState = qs("#me-tk-topic-state", root);
    function setTopicState(kind, text) {
      if (topicState) {
        topicState.className = "me-tk-topic-state me-tk-topic-state-" + kind;
        topicState.innerHTML = escHtml(text);
      }
    }
    function loadTopics() {
      if (!topicSel) return;
      topicSel.disabled = true;
      topicSel.innerHTML = '<option value="">Loading topics…</option>';
      setTopicState("loading", "Loading available topics…");
      if (!shopCode) {
        topicSel.innerHTML = '<option value="">Topics are not configured yet</option>';
        setTopicState("error", "Topics are unavailable right now. You can still send a request without choosing one.");
        return;
      }
      apiGet("/api/ticket/topicList", { shopCode: shopCode }, function (res) {
        topicSel.disabled = false;
        if (res.code === 0 && Array.isArray(res.topics) && res.topics.length) {
          topicSel.innerHTML = '<option value="">Select a topic (optional)</option>';
          for (var t = 0; t < res.topics.length; t++) {
            var opt = document.createElement("option");
            opt.value = res.topics[t].id;
            opt.textContent = res.topics[t].name;
            topicSel.appendChild(opt);
          }
          setTopicState("ready", "");
        } else if (res.code === 0) {
          topicSel.innerHTML = '<option value="">No topics available — you can continue without one</option>';
          setTopicState("empty", "No topics are available right now. You can still send a request without choosing one.");
        } else {
          topicSel.innerHTML = '<option value="">Topics unavailable — try again</option>';
          setTopicState("error", "Topics could not be loaded. You can retry or continue without choosing one.");
          addTopicRetry();
        }
      });
    }
    function addTopicRetry() {
      if (!topicState || qs("#me-tk-topic-retry", root)) return;
      var retry = document.createElement("button");
      retry.type = "button";
      retry.id = "me-tk-topic-retry";
      retry.className = "me-tk-topic-retry";
      retry.textContent = "Retry";
      retry.addEventListener("click", function () {
        retry.remove();
        loadTopics();
      });
      topicState.appendChild(retry);
    }
    if (topicSel) loadTopics();

    /* ── Auto-fill logged-in user ── */
    if (customerEmail) {
      var emailInput = qs("#me-tk-email", root);
      if (emailInput) emailInput.value = customerEmail;
    }
    if (customerName) {
      var nameInput = qs("#me-tk-name", root);
      if (nameInput) nameInput.value = customerName;
    }

    /* ── Submit form ── */
    var submitForm = qs("#me-tk-submit-form", root);
    var submitBtn = qs("#me-tk-submit-btn", root);
    var submitResult = qs("#me-tk-submit-result", root);

    /* 已选择并压缩好的文件列表（最多 5 张） */
    var submitFiles = [];

    /* 渲染提交页图片缩略图列表 */
    function renderSubmitPreviews() {
      var previewEl = qs("#me-tk-attach-preview", root);
      if (!previewEl) return;
      if (submitFiles.length === 0) {
        previewEl.style.display = "none";
        previewEl.innerHTML = "";
        return;
      }
      var html = '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:8px;">';
      for (var i = 0; i < submitFiles.length; i++) {
        html += '<div style="position:relative;display:inline-block;">' +
          '<img src="' + URL.createObjectURL(submitFiles[i]) + '" style="width:80px;height:80px;object-fit:cover;border-radius:6px;border:1px solid #e5e7eb;">' +
          '<a data-idx="' + i + '" style="position:absolute;top:-6px;right:-6px;width:18px;height:18px;background:#ef4444;color:#fff;border-radius:50%;font-size:12px;line-height:18px;text-align:center;cursor:pointer;text-decoration:none;" title="Remove">&times;</a>' +
          '</div>';
      }
      html += '</div>';
      previewEl.style.display = "block";
      previewEl.innerHTML = html;
      var removeBtns = previewEl.querySelectorAll("a[data-idx]");
      for (var b = 0; b < removeBtns.length; b++) {
        removeBtns[b].addEventListener("click", function (e) {
          e.preventDefault();
          var idx = parseInt(this.getAttribute("data-idx"), 10);
          submitFiles.splice(idx, 1);
          renderSubmitPreviews();
        });
      }
    }

    /* 监听提交页文件选择 */
    var submitFileInput = qs("#me-tk-attachment", root);
    if (submitFileInput) {
      submitFileInput.addEventListener("change", function () {
        var newFiles = submitFileInput.files;
        if (!newFiles || newFiles.length === 0) return;
        var totalSize = 0;
        for (var j = 0; j < submitFiles.length; j++) { totalSize += submitFiles[j].size; }

        var toProcess = [];
        var overLimit = false;
        for (var i = 0; i < newFiles.length; i++) {
          if (submitFiles.length + toProcess.length >= 5) { overLimit = true; break; }
          toProcess.push(newFiles[i]);
        }
        if (overLimit) {
          if (submitResult) submitResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">Maximum 5 images per ticket</div>';
        }
        submitFileInput.value = "";

        /* 压缩后再判定总大小，超限则丢弃该张并提示 */
        var processed = 0;
        if (toProcess.length === 0) return;
        for (var k = 0; k < toProcess.length; k++) {
          (function (file) {
            compressImage(file, function (compressed) {
              var currentTotal = 0;
              for (var j = 0; j < submitFiles.length; j++) { currentTotal += submitFiles[j].size; }
              if (currentTotal + compressed.size > 20 * 1024 * 1024) {
                if (submitResult) submitResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">Total image size exceeds 20MB</div>';
              } else {
                submitFiles.push(compressed);
              }
              processed++;
              if (processed === toProcess.length) {
                renderSubmitPreviews();
              }
            });
          })(toProcess[k]);
        }
      });
    }

    if (submitForm) {
      submitForm.addEventListener("submit", function (e) {
        e.preventDefault();
        if (submitBtn.disabled) return;

        /* client-side validation */
        var emailVal = qs("#me-tk-email", root).value.trim();
        var subjectVal = qs("#me-tk-subject", root).value.trim();
        var messageVal = qs("#me-tk-message", root).value.trim();
        if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
          submitResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">Please enter a valid email address.</div>';
          return;
        }
        if (!subjectVal) {
          submitResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">Please enter a subject.</div>';
          return;
        }
        if (!messageVal) {
          submitResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">Please enter a message.</div>';
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = "Submitting...";
        submitResult.innerHTML = "";

        /* 串行上传所有图片，收集 URL 后提交工单 */
        function uploadAllAndSubmit(files, idx, urls) {
          if (idx >= files.length) { doSubmit(urls); return; }
          var fd = new FormData();
          fd.append("file", files[idx]);
          apiPost("/api/ticket/uploadImage", fd, function (r) {
            if (r.code === 0 && r.url) {
              urls.push(r.url);
              uploadAllAndSubmit(files, idx + 1, urls);
            } else {
              submitBtn.disabled = false;
              submitBtn.textContent = "Send request";
              submitResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">' + escHtml(r.msg || "Image upload failed") + '</div>';
            }
          });
        }

        function doSubmit(urls) {
          var content = escHtml(messageVal).replace(/\n/g, "<br>");
          if (urls && urls.length) {
            for (var k = 0; k < urls.length; k++) {
              var absUrl = urls[k].indexOf("http") === 0 ? urls[k] : erpBase + (urls[k].indexOf('/') === 0 ? '' : '/') + urls[k];
              content += '<br><img src="' + escHtml(absUrl) + '" style="max-width:100%; border-radius:8px; margin-top:10px;">';
            }
          }

          var fd = new FormData();
          fd.append("shopCode", shopCode);
          fd.append("customerEmail", emailVal);
          var nameVal2 = qs("#me-tk-name", root).value.trim();
          if (nameVal2) fd.append("customerName", nameVal2);
          fd.append("subject", subjectVal);
          var orderNoVal = qs("#me-tk-order-no", root).value.trim();
          if (orderNoVal) fd.append("orderNo", orderNoVal);
          var topicVal = qs("#me-tk-topic", root).value;
          if (topicVal) fd.append("topicId", topicVal);
          fd.append("content", content);
          if (customerId) fd.append("customerId", customerId);

          apiPost("/api/ticket/submit", fd, function (res) {
            submitBtn.disabled = false;
            submitBtn.textContent = "Send request";
            if (res.code === 0) {
              submitForm.style.display = "none";
              submitResult.innerHTML =
                '<div class="me-tk-alert me-tk-alert-success">' +
                '<strong>Your request has been submitted.</strong><br>' +
                'Ticket ID: <strong>' + escHtml(res.ticketNo) + '</strong><br>' +
                'We will reply to you via email. You can also check your ticket status anytime.<br><br>' +
                '<button class="me-tk-btn me-tk-btn-outline me-tk-btn-sm" id="me-tk-goto-check">Check My Ticket &rarr;</button>' +
                '</div>';
              var gotoCheck = qs("#me-tk-goto-check", root);
              if (gotoCheck) {
                gotoCheck.addEventListener("click", function () {
                  activateTab(1);
                  var noInput = qs("#me-tk-check-no", root);
                  if (noInput) noInput.value = res.ticketNo;
                  var checkEmail = qs("#me-tk-check-email", root);
                  if (checkEmail) checkEmail.value = emailVal;
                });
              }
            } else {
              submitResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">' + escHtml(res.msg || "Submit failed") + '</div>';
            }
          });
        }

        if (submitFiles.length > 0) {
          uploadAllAndSubmit(submitFiles, 0, []);
        } else {
          doSubmit([]);
        }
      });
    }

    /* ── Check ticket ── */
    var checkForm = qs("#me-tk-check-form", root);
    var checkResult = qs("#me-tk-check-result", root);
    var checkBtn = qs("#me-tk-check-btn", root);

    if (checkForm) {
      checkForm.addEventListener("submit", function (e) {
        e.preventDefault();
        if (checkBtn.disabled) return;
        var email = qs("#me-tk-check-email", root).value.trim();
        var no = qs("#me-tk-check-no", root).value.trim();
        if (!email || !no) {
          checkResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">Please enter both Email and Ticket ID.</div>';
          return;
        }
        checkBtn.disabled = true;
        checkBtn.textContent = "Searching...";
        checkResult.innerHTML = '<div class="me-tk-loading"><span class="me-tk-spinner"></span> Loading...</div>';

        apiGet("/api/ticket/queryByNo", { ticketNo: no, email: email }, function (res) {
          checkBtn.disabled = false;
          checkBtn.textContent = "Check";
          if (res.code === 0 && res.ticket) {
            renderTicketDetail(checkResult, res.ticket, res.messages || []);
          } else {
            checkResult.innerHTML = '<div class="me-tk-alert me-tk-alert-error">' + escHtml(res.msg || "Ticket not found") + '</div>';
          }
        });
      });
    }
  }

  /* ── Render ticket detail (shared by Check & My Support) ── */
  /* 把消息HTML中的相对路径图片转为ERP绝对路径，防止Shopify端404 */
  function fixImageUrls(html) {
    if (!html || !erpBase) return html;
    return html.replace(/<img([^>]+)src=["']([^"']+)["']/gi, function(match, attr, src) {
      if (src.indexOf('http') === 0 || src.indexOf('data:') === 0) return match;
      var cleanSrc = src.replace(/^\//, '');
      var fullUrl = erpBase + '/' + cleanSrc;
      return '<img' + attr + 'src="' + fullUrl + '"';
    });
  }

  function renderTicketDetail(container, ticket, messages) {
    var html = '<div class="me-tk-detail-header">' +
      '<h3>' + escHtml(ticket.subject || "") + '</h3>' +
      '<div class="me-tk-detail-meta">' +
      '<span>Ticket: <strong>' + escHtml(ticket.ticketNo || "") + '</strong></span>' +
      statusHtml(ticket.status, ticket.statusLabel) +
      '<span>' + escHtml(formatDate(ticket.createDate)) + '</span>' +
      '</div></div>';

    html += '<div class="me-tk-messages">';
    if (messages.length === 0) {
      html += '<div class="me-tk-empty">No messages yet.</div>';
    }
    for (var i = 0; i < messages.length; i++) {
      var m = messages[i];
      var isCustomer = String(m.direction) === "1";
      var cls = isCustomer ? "me-tk-msg-customer" : "me-tk-msg-staff";
      html += '<div class="me-tk-msg ' + cls + '">';
      html += '<div class="me-tk-msg-sender">' + escHtml(isCustomer ? (ticket.customerName || ticket.customerEmail || "You") : (m.sender || "Support")) + '</div>';
      html += '<div class="me-tk-msg-body">' + fixImageUrls(m.content || "") + '</div>';
      html += '<div class="me-tk-msg-time">' + escHtml(formatDate(m.createDate)) + '</div>';
      html += '</div>';
    }
    html += '</div>';

    /* 回复表单：close 状态也保持可见，发送后端会自动重开 */
    /* ── 优化后的回复框 HTML 结构 ── */
    html += '<div class="me-tk-reply-box">';
    if (String(ticket.status) === "4") {
      html += '<div class="me-tk-reopen-hint" style="background:#f0fdf4;border:1px solid #86efac;color:#166534;padding:8px 12px;border-radius:6px;margin-bottom:15px;font-size:13px;">This ticket is closed. Reply to reopen.</div>';
    }
    html += '<h4>Reply</h4>' +
      '<div class="me-tk-field">' +
      '<textarea id="me-tk-reply-msg" placeholder="Type your reply..."></textarea>' +
      '</div>' +
      '<div class="me-tk-reply-attach">' +
      '<label class="me-tk-attach-label" for="me-tk-reply-file">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:5px;"><path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"/></svg>' +
      'Attach Image' +
      '</label>' +
      '<input type="file" accept="image/*" multiple id="me-tk-reply-file" style="display:none;">' +
      '<span id="me-tk-attach-name" style="font-size:12px; color:#999;"></span>' +
      '</div>' +
      '<div id="me-tk-attach-preview" style="margin:10px 0;"></div>' +
      '<div style="margin-top:20px;">' +
      '<button class="me-tk-btn me-tk-btn-primary" id="me-tk-reply-btn" style="width:auto; min-width:150px;">Send Reply</button>' +
      '<span id="me-tk-reply-status" style="margin-left:15px; font-size:13px;"></span>' +
      '</div></div>';

    container.innerHTML = html;

    /* 绑定附件（多图版） */
    var fileInput = qs("#me-tk-reply-file", container);
    var attachName = qs("#me-tk-attach-name", container);
    var attachPreview = qs("#me-tk-attach-preview", container);
    var replyFiles = [];  /* 回复区独立文件列表，随 renderTicketDetail 重新初始化 */

    function renderReplyPreviews() {
      if (!attachPreview) return;
      if (replyFiles.length === 0) {
        attachPreview.innerHTML = "";
        return;
      }
      var html = '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:8px;">';
      for (var i = 0; i < replyFiles.length; i++) {
        html += '<div style="position:relative;display:inline-block;">' +
          '<img src="' + URL.createObjectURL(replyFiles[i]) + '" style="width:80px;height:80px;object-fit:cover;border-radius:6px;border:1px solid rgba(255,255,255,0.1);">' +
          '<a data-idx="' + i + '" style="position:absolute;top:-6px;right:-6px;width:18px;height:18px;background:#ef4444;color:#fff;border-radius:50%;font-size:12px;line-height:18px;text-align:center;cursor:pointer;text-decoration:none;" title="Remove">&times;</a>' +
          '</div>';
      }
      html += '</div>';
      attachPreview.innerHTML = html;
      var removeBtns = attachPreview.querySelectorAll("a[data-idx]");
      for (var b = 0; b < removeBtns.length; b++) {
        removeBtns[b].addEventListener("click", function (e) {
          e.preventDefault();
          var idx = parseInt(this.getAttribute("data-idx"), 10);
          replyFiles.splice(idx, 1);
          renderReplyPreviews();
          if (attachName) attachName.textContent = replyFiles.length > 0 ? replyFiles.length + " image(s)" : "";
        });
      }
    }

    if (fileInput) {
      fileInput.addEventListener("change", function () {
        var newFiles = fileInput.files;
        if (!newFiles || newFiles.length === 0) return;
        var statusEl = qs("#me-tk-reply-status", container);
        var totalSize = 0;
        for (var j = 0; j < replyFiles.length; j++) { totalSize += replyFiles[j].size; }

        var toProcess = [];
        var overLimit = false;
        for (var i = 0; i < newFiles.length; i++) {
          if (replyFiles.length + toProcess.length >= 5) { overLimit = true; break; }
          toProcess.push(newFiles[i]);
        }
        if (overLimit) {
          if (statusEl) statusEl.innerHTML = '<span style="color:#ef4444;">Maximum 5 images per ticket</span>';
        }
        fileInput.value = "";

        /* 压缩后再判定总大小，超限则丢弃该张并提示 */
        var processed = 0;
        if (toProcess.length === 0) return;
        for (var k = 0; k < toProcess.length; k++) {
          (function (file) {
            compressImage(file, function (compressed) {
              var currentTotal = 0;
              for (var j = 0; j < replyFiles.length; j++) { currentTotal += replyFiles[j].size; }
              if (currentTotal + compressed.size > 20 * 1024 * 1024) {
                if (statusEl) statusEl.innerHTML = '<span style="color:#ef4444;">Total image size exceeds 20MB</span>';
              } else {
                replyFiles.push(compressed);
              }
              processed++;
              if (processed === toProcess.length) {
                renderReplyPreviews();
                if (attachName) attachName.textContent = replyFiles.length > 0 ? replyFiles.length + " image(s)" : "";
              }
            });
          })(toProcess[k]);
        }
      });
    }

    /* 绑定回复按钮 */
    var replyBtn = qs("#me-tk-reply-btn", container);
    if (replyBtn) {
      replyBtn.addEventListener("click", function () {
        var msgEl = qs("#me-tk-reply-msg", container);
        var statusEl = qs("#me-tk-reply-status", container);
        var text = (msgEl.value || "").trim();
        if (!text && replyFiles.length === 0) { statusEl.innerHTML = '<span style="color:#ef4444;">Please enter a message or attach an image.</span>'; return; }
        replyBtn.disabled = true;
        replyBtn.textContent = "Sending...";
        statusEl.innerHTML = "";

        /* 串行上传所有回复图片 */
        function uploadAllAndReply(files, idx, urls) {
          if (idx >= files.length) { doReply(urls); return; }
          var fd = new FormData();
          fd.append("file", files[idx]);
          apiPost("/api/ticket/uploadImage", fd, function (r) {
            if (r.code === 0 && r.url) {
              urls.push(r.url);
              uploadAllAndReply(files, idx + 1, urls);
            } else {
              replyBtn.disabled = false;
              replyBtn.textContent = "Send Reply";
              statusEl.innerHTML = '<span style="color:#ef4444;">' + escHtml(r.msg || "Image upload failed") + '</span>';
            }
          });
        }

        function doReply(urls) {
          var content = escHtml(text).replace(/\n/g, "<br>");
          if (urls && urls.length) {
            for (var k = 0; k < urls.length; k++) {
              var absUrl = urls[k].indexOf("http") === 0 ? urls[k] : erpBase + urls[k];
              content += '<br><img src="' + escHtml(absUrl) + '" style="max-width:400px;">';
            }
          }
          var email = ticket.customerEmail || customerEmail;
          var fd = new FormData();
          fd.append("ticketNo", ticket.ticketNo);
          fd.append("email", email);
          fd.append("content", content);
          apiPost("/api/ticket/reply", fd, function (res) {
            replyBtn.disabled = false;
            replyBtn.textContent = "Send Reply";
            if (res.code === 0) {
              msgEl.value = "";
              replyFiles = [];
              if (attachPreview) attachPreview.innerHTML = "";
              if (attachName) attachName.textContent = "";
              var sentMsg = (String(ticket.status) === "4") ? "Reply sent. This ticket has been reopened so our team can follow up." : "Reply sent!";
              statusEl.innerHTML = '<span style="color:#22c55e;">' + escHtml(sentMsg) + '</span>';
              apiGet("/api/ticket/queryByNo", { ticketNo: ticket.ticketNo, email: email }, function (r2) {
                if (r2.code === 0 && r2.ticket) {
                  renderTicketDetail(container, r2.ticket, r2.messages || []);
                }
              });
            } else {
              statusEl.innerHTML = '<span style="color:#ef4444;">' + escHtml(res.msg || "Failed") + '</span>';
            }
          });
        }

        if (replyFiles.length > 0) {
          uploadAllAndReply(replyFiles, 0, []);
        } else {
          doReply([]);
        }
      });
    }
  }

  /* ══════════════════════════════════════
     My Support Page (Account embedded)
     ══════════════════════════════════════ */
  if (pageMode === "my-support") {
    initMySupportPage();
  }

  function initMySupportPage() {
    var listContainer = qs("#me-tk-my-list", root);
    var detailContainer = qs("#me-tk-my-detail", root);

    if (!customerEmail || !customerId) {
      if (listContainer) {
        listContainer.innerHTML = '<div class="me-tk-login-prompt">Please <a href="/account/login">log in</a> to view your support tickets.</div>';
      }
      return;
    }

    loadMyTickets();

    function loadMyTickets() {
      listContainer.innerHTML = '<div class="me-tk-loading"><span class="me-tk-spinner"></span> Loading tickets...</div>';
      if (detailContainer) detailContainer.style.display = "none";
      listContainer.style.display = "block";

      apiGet("/api/ticket/queryByCustomer", { email: customerEmail, customerId: customerId, shopCode: shopCode }, function (res) {
        if (res.code !== 0 || !res.tickets || res.tickets.length === 0) {
          listContainer.innerHTML = '<div class="me-tk-empty">No support tickets found.</div>';
          return;
        }
        renderTicketList(res.tickets);
      });
    }

    function renderTicketList(tickets) {
      var html = '<table class="me-tk-list-table"><thead><tr>' +
        '<th>Ticket ID</th><th>Subject</th><th>Last Updated</th><th>Status</th><th></th>' +
        '</tr></thead><tbody>';
      for (var i = 0; i < tickets.length; i++) {
        var t = tickets[i];
        html += '<tr>' +
          '<td>' + escHtml(t.ticketNo || "") + '</td>' +
          '<td>' + escHtml(t.subject || "") + '</td>' +
          '<td>' + escHtml(formatDate(t.updateDate || t.createDate)) + '</td>' +
          '<td>' + statusHtml(t.status, t.statusLabel) + '</td>' +
          '<td><button class="me-tk-view-btn" data-no="' + escHtml(t.ticketNo || "") + '">View</button></td>' +
          '</tr>';
      }
      html += '</tbody></table>';
      listContainer.innerHTML = html;

      /* bind view buttons */
      var btns = qsa(".me-tk-view-btn", listContainer);
      for (var b = 0; b < btns.length; b++) {
        btns[b].addEventListener("click", function () {
          var no = this.getAttribute("data-no");
          loadTicketDetail(no);
        });
      }
    }

    function loadTicketDetail(ticketNo) {
      listContainer.style.display = "none";
      detailContainer.style.display = "block";
      detailContainer.innerHTML = '<div class="me-tk-loading"><span class="me-tk-spinner"></span> Loading...</div>';

      apiGet("/api/ticket/queryByNo", { ticketNo: ticketNo, email: customerEmail }, function (res) {
        if (res.code === 0 && res.ticket) {
          detailContainer.innerHTML = '<div class="me-tk-back-btn"><a href="javascript:void(0)" id="me-tk-back">&larr; Back to list</a></div><div id="me-tk-detail-body"></div>';
          renderTicketDetail(qs("#me-tk-detail-body", detailContainer), res.ticket, res.messages || []);
          qs("#me-tk-back", detailContainer).addEventListener("click", function () {
            loadMyTickets();
          });
        } else {
          detailContainer.innerHTML = '<div class="me-tk-alert me-tk-alert-error">' + escHtml(res.msg || "Failed to load ticket") + '</div>';
        }
      });
    }
  }
})();
